function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import classNames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultDropIcon = /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200",
  children: /*#__PURE__*/_jsx("path", {
    d: "M768 384l-256 320L256 384z"
  })
});
var defaultClearIcon = /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200",
  children: /*#__PURE__*/_jsx("path", {
    d: "M295.424 256.213333L512 472.746667l216.576-216.576 39.253333 39.253333L551.168 512l216.576 216.576-39.253333 39.253333L512 551.168l-216.576 216.576-39.253333-39.253333L472.832 512 256.213333 295.424z"
  })
});
var MultiDisplay = function MultiDisplay(props) {
  var _props$value = props.value,
    value = _props$value === void 0 ? [] : _props$value,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? "请选择" : _props$placeholder,
    customText = props.customText,
    clearIcon = props.clearIcon,
    onChange = props.onChange,
    prefixClass = props.prefixClass,
    dropIcon = props.dropIcon;
  return /*#__PURE__*/_jsxs("span", {
    className: classNames("".concat(prefixClass, "MultiSelectDisplay"), _defineProperty({}, "".concat(prefixClass, "MultiSelectDisplay--clearable"), clearIcon !== false && value.length)),
    children: [/*#__PURE__*/_jsx("span", {
      className: "".concat(prefixClass, "MultiSelectDisplayText"),
      children: (customText === null || customText === void 0 ? void 0 : customText(value, data)) || placeholder
    }), !!value.length && /*#__PURE__*/_jsx("span", {
      className: "".concat(prefixClass, "MultiSelectDisplayLength"),
      children: value.length
    }), dropIcon !== false && (dropIcon || defaultDropIcon), clearIcon !== false && !!value.length && /*#__PURE__*/_jsx("span", {
      className: "".concat(prefixClass, "MultiSelectDisplayClear"),
      onClick: function onClick(ev) {
        return onChange === null || onChange === void 0 ? void 0 : onChange({
          value: undefined,
          event: ev
        });
      },
      children: clearIcon || defaultClearIcon
    })]
  });
};
MultiDisplay.defaultProps = {
  prefixClass: "yk",
  clearIcon: false
};
export default MultiDisplay;